export default __webpack_public_path__ + "static/media/casc_logo.eba3042d.png";